export default {
  common: {
    search: 'Rechercher',
    sortByDate: 'Trier par date',
    sortByUrl: 'Trier par URL',
    noResults: 'Aucun résultat trouvé pour',
    success: 'Opération réussie',
    error: 'Une erreur est survenue',
    copied: '{{type}} copié dans le presse-papiers',
    copyError: 'Échec de la copie dans le presse-papiers',
    user: 'Utilisateur',
    showMore: 'Voir plus {{count}}',
    showLess: 'Voir moins',
    backToDashboard: 'Voir le tableau de bord',
    optional: 'optionnel'
  },
  notifications: {
    title: 'Notifications',
    clearAll: 'Tout effacer',
    empty: 'Aucune notification',
    newUpdate: {
      title: 'Nouvelle mise à jour disponible',
      message: 'La version {{version}} est maintenant disponible avec de nouvelles fonctionnalités et améliorations.',
      action: 'Mettre à jour maintenant'
    },
    license: {
      activated: {
        title: 'Licence activée',
        message: 'Votre licence a été activée avec succès.',
        action: 'Voir le tableau de bord'
      },
      deactivated: {
        title: 'Licence désactivée',
        message: 'La licence pour {{url}} a été désactivée avec succès.',
        action: 'Activer une nouvelle licence'
      },
      error: {
        title: "Échec de l'activation",
        message: 'Échec de l\'activation de la licence. Veuillez vérifier vos identifiants.',
        action: 'Réessayer'
      },
      deactivationError: {
        title: 'Échec de la désactivation',
        message: 'Échec de la désactivation de la licence. Veuillez réessayer.',
        action: 'Contacter le support'
      }
    },
    auth: {
      error: {
        title: 'Erreur d\'authentification',
        message: 'Email utilisateur non trouvé. Veuillez vous reconnecter.',
        action: 'Se connecter'
      }
    },
    validation: {
      invalidUrl: {
        title: 'Format d\'URL invalide',
        message: 'Veuillez entrer une URL de boutique Shopify valide.'
      },
      invalidToken: {
        title: 'Format de jeton invalide',
        message: 'Le jeton d\'accès doit commencer par "shpat_".'
      }
    }
  },
  auth: {
    login: {
      title: 'Connectez-vous à votre compte',
      email: 'Adresse email',
      password: 'Mot de passe',
      submit: 'Se connecter',
      forgotPassword: 'Mot de passe oublié ?',
      noAccount: "Vous n'avez pas de compte ?",
      register: "S'inscrire maintenant",
      success: 'Connexion réussie',
      rememberMe: 'Se souvenir de moi',
      submitting: 'Connexion en cours...',
      error: {
        invalid: 'Email ou mot de passe invalide',
        generic: 'Une erreur est survenue lors de la connexion',
        blocked: 'Compte temporairement bloqué. Veuillez réessayer dans {{minutes}} minutes.',
        temporarilyBlocked: 'Compte temporairement bloqué',
        tryAgainIn: 'Réessayez dans:'
      }
    },
    register: {
      title: 'Créez votre compte',
      name: 'Nom complet',
      email: 'Adresse email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmez le mot de passe',
      submit: 'Créer un compte',
      haveAccount: 'Vous avez déjà un compte ?',
      signIn: 'Se connecter',
      success: 'Compte créé avec succès',
      submitting: 'Création en cours...',
      error: {
        passwordMismatch: 'Les mots de passe ne correspondent pas',
        emailInUse: 'Cet email est déjà utilisé',
        weak: 'Le mot de passe est trop faible',
        generic: "Une erreur est survenue lors de l'inscription"
      }
    },
    forgotPassword: {
      title: 'Réinitialiser votre mot de passe',
      subtitle: 'Entrez votre adresse e-mail pour recevoir un lien de réinitialisation',
      email: 'Adresse e-mail',
      emailPlaceholder: 'Entrez votre adresse e-mail',
      submit: 'Envoyer le lien',
      backToLogin: 'Retour à la connexion',
      success: 'E-mail de réinitialisation envoyé',
      checkEmail: 'Vérifiez votre boîte de réception pour le lien de réinitialisation',
      error: {
        notFound: 'Aucun compte trouvé avec cette adresse e-mail',
        generic: 'Une erreur est survenue. Veuillez réessayer.'
      }
    },
    logout: {
      button: 'Se déconnecter',
      success: 'Déconnexion réussie',
      error: 'Erreur lors de la déconnexion'
    }
  },
  nav: {
    dashboard: 'Tableau de Bord',
    firststeps: 'Premiers pas',
    services: 'Services',
    changelog: 'Actualités',
    activate: 'Activer',
    deactivate: 'Désactiver',
    update: 'Mettre à jour',
    profile: 'Profil',
    resources: 'Ressources',
    ticket: 'Créer un Ticket',
    reviewguide: 'Revoir le guide',
    preferences: 'Préférences',
    download: 'Télécharger',
    installTheme: 'Installer le thème',
    buyLicense: 'Acheter une licence',
    documentation: 'Documentation',
    sections: {
      main: 'Principal',
      licenses: 'Gestion des licences',
      admin: 'Administration'
    },
    admin: {
      notifications: 'Notifications',
      licensesList: 'Liste Licences',
      usersList: 'Liste Utilisateurs',
      createLicense: 'Créer Licence',
      activateLicense: 'Activer Licence',
      deactivateLicense: 'Désactiver Licence',
      removeLicense: 'Supprimer Licence'
    }
  },
  dashboard: {
    title: 'Tableau de Bord',
    greeting: 'Bonjour, {{name}}',
    welcome: 'Bienvenue sur votre espace de gestion des licences Shopiweb Premium',
    reviewguide: 'Revoir le guide',
    stats: {
      authorized: {
        label: 'Licences Autorisées',
        purchased: 'licences achetées',
        period: 'Gérez vos licences Premium',
        description: 'Total de licences premium autorisées par boutique'
      },
      available: {
        label: 'Licences Disponibles',
        remaining: 'licences restantes',
        period: 'Prêtes à être activées',
        description: 'Licences disponibles pour de nouvelles boutiques'
      },
      installed: {
        label: 'Licences Installées',
        period: 'En cours d\'utilisation',
        description: 'Licences actuellement actives sur vos boutiques'
      }
    },
    shopifyUrls: {
      title: 'URLs Shopify Actifs',
      status: {
        active: 'Active',
        inactive: 'Inactive',
        pending: 'En attente'
      },
      lastActivity: 'Dernière Activité',
      plan: 'Plan',
      credentials: {
        show: 'Afficher les Identifiants',
        hide: 'Masquer les Identifiants',
        accessToken: "Jeton d'accès",
        apiSecret: 'Clé Secrète API'
      }
    },
    licenseStatus: {
      title: 'État des Licences',
      subtitle: 'Disponibilité des licences en temps réel',
      active: 'Active',
      available: 'Disponible',
      licenses: 'licences',
      utilization: 'Utilisation',
      unusedLicenses: 'licences inutilisées disponibles',
      readyForInstallation: 'Prêtes pour de nouvelles installations',
      activateNew: 'Activer une Nouvelle Licence',
      purchaseNew: 'Acheter une Nouvelle licence',
      noLicensesAvailable: 'Vous n\'avez plus de licences disponibles !',
      purchaseOrDeactivate: 'Pour en installer une nouvelle, veuillez en acheter une ou désactiver une licence existante.'
    }
  },
  loyalty: {
    program: 'Programme Fidélité',
    learnMore: 'En savoir plus sur les crédits',
    availablePoints: 'points disponibles',
    estimatedValue: 'Valeur estimée : {{value}}',
    usePoints: 'Utiliser mes points',
    info: {
      pointValue: '• 1 point = 0,05€',
      earnPoints: '• Points gagnés avec l\'achat de licences Premium',
      usePoints: '• Utilisables pour l\'achat de produits et services Shopiweb'
    },
    modal: {
      title: 'Utiliser mes points',
      pointsToUse: 'Points à utiliser',
      pointsRequired: 'Points requis',
      availablePoints: 'Points disponibles : {{points}}',
      estimatedValue: 'Valeur estimée : {{value}}',
      warning: 'Votre demande sera traitée dans les 24-48h ouvrées.',
      continue: 'Continuer',
      cancel: 'Annuler',
      processing: 'Envoi en cours...',
      requestSent: 'Votre demande de {{points}} points a été envoyée avec succès. Il vous reste {{remaining}} points.',
      validation: {
        acceptRequired: 'Veuillez accepter les conditions d\'utilisation avant de télécharger.',
        insufficientPoints: 'Vous n\'avez pas assez de points disponibles.',
        invalidAmount: 'Veuillez entrer un nombre valide de points.'
      }
    }
  },
  activate: {
    title: 'Activation de la licence Shopiweb Premium',
    subtitle: 'Renseignez les informations ci-dessous pour activer votre licence sur la boutique Shopify de votre choix.',
    success: 'Licence activée avec succès !',
    error: {
      invalidCredentials: 'Les identifiants fournis sont incorrects. Veuillez vérifier vos informations et réessayer.'
    },
    form: {
      email: {
        label: 'Adresse email',
        placeholder: 'Entrez votre adresse email',
        help: "Adresse utilisée lors de l'achat de la licence"
      },
      shopifyUrl: {
        label: 'URL de votre boutique',
        placeholder: 'votreboutique.myshopify.com',
        help: 'URL exacte de la boutique sur laquelle activer la licence'
      },
      apiKey: {
        label: "Clé secrète API",
        placeholder: '57d4d708e2efa858df6f93d1799506de',
        help: 'Disponible dans la section "Identifiants API" de votre boutique Shopify'
      },
      accessToken: {
        label: 'Jeton API Shopify',
        placeholder: 'shpat_xxxxxxxxxxxxxxxxxxxxxxxxx',
        help: 'Généré dans la section "Identifiants API" de votre boutique Shopify'
      },
      validation: {
        invalidUrl: 'Le format de l’URL Shopify est invalide',
        invalidToken: 'Le jeton d\'accès doit commencer par "shpat_"'
      },
      submit: 'Activer la licence',
      submitting: 'Activation en cours...'
    }
  },
  deactivate: {
    title: 'Désactivation de la licence Shopiweb Premium',
    subtitle: 'Désactiver la licence Shopiweb Premium de votre boutique Shopify',
    success: 'Licence désactivée avec succès.',
    error: 'Échec de la désactivation de la licence. Veuillez réessayer.',
    notFound: 'Aucune licence active trouvée pour cette boutique.',
    warning: 'La désactivation de votre licence entraînera immédiatement la perte d’accès à toutes les fonctionnalités Premium. Cette action est irréversible.',
    form: {
      shopifyUrl: {
        label: 'URL de votre boutique',
        placeholder: 'votreboutique.myshopify.com',
        help: 'Sélectionnez une de vos boutiques ou saisissez l\'URL manuellement'
      },
      apiKey: {
        label: "Clé secrète API",
        placeholder: '57d4d708e2efa858df6f93d1799506de',
        help: 'La même clé API utilisée lors de l\’activation de la licence sur cette boutique'
      },
      submit: 'Désactiver la licence',
      submitting: 'Désactivation en cours...'
    },
    modal: {
      title: 'Confirmer la désactivation',
      message: 'Êtes-vous sûr de vouloir désactiver la licence pour {{url}} ?',
      warning: 'Cette action est irréversible et supprimera immédiatement l\’accès aux fonctionnalités Premium.',
      confirm: 'Oui, désactiver',
      cancel: 'Annuler'
    }
  },
  update: {
    headerTitle: 'Mise à jour du thème',
    headerSubtitle: 'Mettez à jour votre thème Shopiweb Premium vers la dernière version disponible.',
    title: 'Mise à jour du thème',
    subtitle: 'Profitez des dernières fonctionnalités, optimisations et correctifs avec la version la plus récente du thème Shopiweb Premium.',
    currentVersion: 'Disponible',
    availableVersion: 'À venir',
    success: 'Thème mis à jour avec succès',
    successRetrieved: 'Thèmes récupérés avec succès',
    themesRetrieved: 'Les thèmes non publiés de votre boutique ont été récupérés avec succès.',
    warning: 'Attention',
    selectTheme: 'Veuillez sélectionner un thème à mettre à jour',
    selectThemePlaceholder: 'Sélectionnez un thème',
    error: 'La mise à jour du thème a échoué. Veuillez réessayer.',
    fetchError: 'Échec de la récupération des thèmes disponibles.',
    themeUpdated: 'N\'oubliez pas de rafraîchir la page de votre boutique Shopify dans environ 5 minutes pour visualiser les modifications et profiter de la nouvelle version',
    form: {
      email: {
        label: 'Adresse email',
        placeholder: 'Entrez votre adresse email',
        help: 'Adresse utilisée lors de l’achat de la licence'
      },
      shopifyUrl: {
        label: 'URL de votre boutique',
        placeholder: 'votreboutique.myshopify.com',
        help: 'Sélectionnez une de vos boutiques ou saisissez l\'URL manuellement'
      },
      apiKey: {
        label: "Clé secrète API",
        placeholder: '57d4d708e2efa858df6f93d1799506de',
        help: 'La même clé API utilisée lors de l’activation de la licence sur cette boutique'
      },
      submit: 'Mettre à jour le thème',
      submitting: 'Mise à jour en cours...',
      loading: 'Chargement des thèmes...',
      loadThemes: 'Charger les thèmes disponibles'
    },
    modal: {
      title: 'Confirmer la mise à jour',
      message: 'Êtes-vous sûr de vouloir mettre à jour le thème pour {{url}} ?',
      confirm: 'Oui, mettre à jour',
      cancel: 'Annuler'
    }
  },
  download: {
    headerTitle: 'Téléchargement manuel (optionnel)',
    headerSubtitle: 'Téléchargez manuellement la dernière version du thème si vous ne souhaitez pas utiliser l’installation automatique.',
    title: 'Télécharger Shopiweb Premium',
    subtitle: 'Version stable la plus récente du thème, incluant toutes les fonctionnalités premium.',
    currentVersion: 'Version actuelle',
    availableVersion: 'Version disponible',
    beforeDownload: {
      title: 'Avant de télécharger (optionnel)',
      items: [
        'Vérifiez que votre licence est active',
        'Sauvegardez votre thème actuel',
        'Assurez-vous de la compatibilité avec votre boutique'
      ]
    },
    form: {
      termsAccept: 'J\'accepte les',
      termsLink: 'conditions d\'utilisation',
      andRead: 'et j\’ai lu le',
      installGuide: 'guide d\'installation',
      downloadButton: 'Télécharger le thème',
      downloadPreparation: 'Préparation du téléchargement en cours...',
      viewDocumentation: 'Accéder à la documentation',
      alternativeDownload: 'Essayer une autre méthode de téléchargement'
    },
    guide: {
      title: 'Guide d\’installation rapide (manuelle)',
      steps: {
        prerequisites: {
          title: 'Pré-requis',
          description: 'Shopify OS 2.0 requis, thème compatible avec la dernière version de Shopify.'
        },
        backup: {
          title: 'Sauvegarde du thème existant',
          description: 'Exportez votre thème actuel depuis l’interface d’administration Shopify.'
        },
        installation: {
          title: 'Installation manuelle',
          description: 'Importez le fichier ZIP dans votre admin Shopify via la section "Thèmes".'
        },
        configuration: {
          title: 'Configuration initiale',
          description: 'Ajustez les paramètres de base du thème selon vos besoins.'
        }
      },
      detailedGuide: 'Voir le guide complet d\’installation'
    },
    notifications: {
      downloadStarted: {
        title: 'Téléchargement lancé',
        message: 'Le thème a été téléchargé avec succès',
        action: 'Consulter le guide d\'installation'
      },
      error: {
        title: 'Erreur lors du téléchargement',
        message: 'Une erreur est survenue pendant le téléchargement. Veuillez réessayer.',
        action: 'Réessayer'
      },
      termsRequired: {
        title: 'Conditions requises',
        message: 'Vous devez accepter les conditions d’utilisation avant de pouvoir télécharger le thème.'
      }
    }
  },
  install: {
    title: 'Installation du thème Shopiweb Premium',
    subtitle: 'Installez rapidement et en toute simplicité le thème Shopiweb Premium sur votre boutique Shopify.',
    success: 'Licence activée avec succès',
    error: {
      invalidCredentials: 'Identifiants invalides. Veuillez vérifier vos informations et réessayer.'
    },
    form: {
      title: 'Informations de connexion',
      subtitle: 'Connexion sécurisée avec détection automatique du jeton d\'accès pour procéder à l\'installation du thème.',
      shopifyUrl: {
        label: 'URL de votre boutique',
        placeholder: 'votreboutique.myshopify.com',
        help: 'Sélectionnez une de vos boutiques ou saisissez l\'URL manuellement'
      },
      accessToken: {
        label: 'Jeton API Shopify',
        placeholder: 'shpat_xxxxxxxxxxxxxxxxxxxxxxxxx',
        help: 'Utilisez le même jeton d’accès API que celui utilisé pour activer la licence de cette boutique'
      },
      validation: 'Thème installé avec succès ! ID du thème:',
      titlesubmit: 'Procéder à l\’installation du thème',
      subtitlesubmit: 'Cliquez sur le bouton ci-dessous pour lancer l\’installation automatique du thème Shopiweb Premium sur votre boutique Shopify.',
      submit: 'Installer le thème',
      submitting: 'Instalation en cours...',
      newsubmit: 'Installer à nouveau'
    }
  },
  profile: {
    title: 'Informations du Profil',
    subtitle: 'Gérez vos informations personnelles et vos paramètres de sécurité',
    personalInfo: 'Informations Personnelles',
    name: 'Nom complet',
    email: 'Adresse e-mail',
    company: 'Entreprise',
    memberSince: 'Membre depuis',
    save: 'Enregistrer les modifications',
    saving: 'Enregistrement...',
    updateSuccess: 'Profil mis à jour avec succès',
    updateError: 'Échec de la mise à jour du profil',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    changePassword: 'Changer le mot de passe',
    validation: {
      nameLength: 'Le nom doit contenir au moins 2 caractères',
      currentPasswordRequired: 'Le mot de passe actuel est requis pour changer de mot de passe',
      currentPasswordInvalid: 'Le mot de passe actuel est incorrect',
      passwordLength: 'Le nouveau mot de passe doit contenir au moins 8 caractères',
      passwordMismatch: 'Les mots de passe ne correspondent pas'
    },
    image: {
      title: 'Photo de profil',
      upload: 'Télécharger une photo',
      uploading: 'Téléchargement...',
      remove: 'Supprimer la photo',
      preview: 'Aperçu de la photo de profil',
      requirements: 'JPG, GIF ou PNG. Taille max 5Mo.',
      invalidType: 'Veuillez télécharger un fichier image',
      tooLarge: "L'image doit faire moins de 5Mo",
      uploadSuccess: 'Photo de profil téléchargée avec succès',
      uploadError: 'Échec du téléchargement de la photo de profil',
      removeSuccess: 'Photo de profil supprimée avec succès',
      removeError: 'Échec de la suppression de la photo de profil',
      loadError: "Impossible de charger l'image",
      processingError: 'Erreur lors du traitement de l\'image',
      invalidDimensions: 'L\'image doit faire au moins 200x200 pixels',
      dragAndDrop: 'Glissez et déposez votre photo ici ou cliquez pour sélectionner',
      dropHere: 'Déposez votre photo ici'
    },
    role: {
      admin: 'Administrateur',
      user: 'Utilisateur'
    },
    stats: {
      memberSince: {
        label: 'Membre depuis',
        tooltip: 'Date d\'inscription sur la plateforme'
      },
      activeLicenses: {
        label: 'Licences actives', 
        tooltip: 'Nombre de licences Premium actuellement actives'
      },
      loyaltyPoints: {
        label: 'Points fidélité',
        tooltip: 'Points cumulés utilisables pour des réductions',
        value: 'Valeur : {{amount}}'
      }
    }
  },
  admin: {
    createLicense: {
      title: 'Création de Licence Premium',
      subtitle: 'Créez de nouvelles licences Premium pour vos clients',
      success: 'Licence créée avec succès'
    },
    deactivateLicense: {
      title: 'Désactivation de Licence Premium',
      subtitle: 'Désactivez de nouvelles licences Premium pour vos clients',
      success: 'Licence désactivée avec succès'
    },
    removeLicense: {
      title: 'Suppression de Licence Premium',
      subtitle: 'Supprimez des licences Premium existantes',
      success: 'Licence supprimée avec succès',
      confirm: 'Êtes-vous sûr de vouloir supprimer cette licence ?'
    }
  }
};